import { css, cx } from '@repo/pandacss/styled-system/css';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';

export type SimpleDetailsProps = CommonProps & {
  variant: 'simple';
  SummaryComponent: ReactNode;
};

const detailsClass = css({
  position: 'relative',
  '& .expand-icon': {
    transitionProperty: '[transform]',
    transitionDuration: '[0.3s]',
  },
  '&[open] .expand-icon': {
    transform: '[rotate(-180deg)]',
  },
  '&:not([open]) .expand-icon': {
    transform: '[rotate(0deg)]',
  },
});

const summaryClass = css({
  listStyleType: 'none',
  cursor: 'pointer',
  '&::-webkit-details-marker': {
    display: 'none',
  },
  _marker: {
    display: 'none',
  },
  WebkitTapHighlightColor: 'transparent',
});

export function SimpleDetails({
  children,
  detailsProps = {},
  summaryComponentProps = {},
  SummaryComponent,
}: SimpleDetailsProps) {
  const { className: detailsClassName, ...restDetailsProps } = detailsProps;
  const { className: summaryClassName, ...restSummaryComponentProps } = summaryComponentProps;
  return (
    <details className={cx(detailsClass, detailsClassName)} {...restDetailsProps}>
      <summary
        data-testid="detail-summary"
        className={cx(summaryClass, summaryClassName)}
        {...restSummaryComponentProps}
      >
        {SummaryComponent}
      </summary>
      {children}
    </details>
  );
}
